import React, { useEffect, useState, useRef } from "react";
import * as utils from "../../utils/utils";
import * as favUtils from "../../utils/favorite.utils";
import styles from "./dashboard.module.scss";
import Favorite from "../../components/favorite/Favorite";
import Title from "../../components/title/Title";
import Carousel from "react-elastic-carousel";

const FavDashboard = (props) => {
    console.log("FavDashboard---props", props)
    const { selectedRegion } = props;
    const [favorites, setFavorites] = useState([])
    //const [favorites, setFavorites] = useState(props.favorites)
   // const [isloading, setIsLoading] = useState(false) //need to set
    const myFavCarousel = useRef(null);
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);


    const viewFavorites = (element) => {
        console.log("View-Favorites in Dashboard", element);
        const { productDivision, customer, sbs, cxScoreDetails, breadcrumb, kpi, nba, group, sasParent, subregion,strategicAccts } = element.InputParameters;
        props.setSubRegion({});
        if (element.ViewType === 1) {//Detail Page
            if (!utils.isEmpty(productDivision) && utils.isEmpty(customer) && utils.isEmpty(sbs) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                productDivision.primaryRecommendation = Array.isArray(productDivision.primaryRecommendation) && productDivision.primaryRecommendation.length > 0 ? productDivision.primaryRecommendation[0] : productDivision.primaryRecommendation;//fix for navigation issue from dashboard Favorite to PD Detail
                props.setProductDivision(productDivision)  
                props.history.push('/dashboard/productdivisiondetail');
            } else if (utils.isEmpty(productDivision) && !utils.isEmpty(customer) && utils.isEmpty(sbs) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                customer.primaryRecommendation = Array.isArray(customer.primaryRecommendation) && customer.primaryRecommendation.length > 0 ? customer.primaryRecommendation[0] : customer.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setCustomer(customer)
                props.history.push("/dashboard/customerdetail");
            } else if (!utils.isEmpty(productDivision) && !utils.isEmpty(sbs) && utils.isEmpty(customer) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                productDivision.primaryRecommendation = Array.isArray(productDivision.primaryRecommendation) && productDivision.primaryRecommendation.length > 0 ? productDivision.primaryRecommendation[0] : productDivision.primaryRecommendation;//fix for navigation issue from dashboard Favorite to PD Detail
                props.setProductDivision(productDivision)  
                sbs.primaryRecommendation = Array.isArray(sbs.primaryRecommendation) && sbs.primaryRecommendation.length > 0 ? sbs.primaryRecommendation[0] : sbs.primaryRecommendation;//fix for navigation issue from dashboard Favorite to SBS Detail
                props.setSelectedSBS(sbs) 
                props.history.push('/dashboard/sbsdetail')
            } else if (!utils.isEmpty(productDivision) && utils.isEmpty(sbs) && !utils.isEmpty(customer) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                productDivision.primaryRecommendation = Array.isArray(productDivision.primaryRecommendation) && productDivision.primaryRecommendation.length > 0 ? productDivision.primaryRecommendation[0] : productDivision.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setProductDivision(productDivision) 
                customer.primaryRecommendation = Array.isArray(customer.primaryRecommendation) && customer.primaryRecommendation.length > 0 ? customer.primaryRecommendation[0] : customer.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setCustomer(customer); 
                props.history.push("/dashboard/customerdetail");
            } else if (!utils.isEmpty(subregion) && utils.isEmpty(productDivision) && utils.isEmpty(sbs) && utils.isEmpty(customer) && utils.isEmpty(strategicAccts)) {
                subregion.primaryRecommendation = Array.isArray(subregion.primaryRecommendation) && subregion.primaryRecommendation.length > 0 ? subregion.primaryRecommendation[0] : subregion.primaryRecommendation;//fix for navigation issue from dashboard Favorite
                props.setSubRegion(subregion);
                props.history.push("/dashboard/subregiondetail");
            }
            else if (!utils.isEmpty(strategicAccts) && utils.isEmpty(subregion) && utils.isEmpty(productDivision) && utils.isEmpty(sbs) && utils.isEmpty(customer)) {
                strategicAccts.primaryRecommendation = Array.isArray(strategicAccts.primaryRecommendation) && strategicAccts.primaryRecommendation.length > 0 ? strategicAccts.primaryRecommendation[0] : strategicAccts.primaryRecommendation;//fix for navigation issue from dashboard Favorite
            props.setStrategicAct(strategicAccts);
            props.history.push("/dashboard/strategicaccountsdetail");
           }
            else {
                group.primaryRecommendation = Array.isArray(group.primaryRecommendation) && group.primaryRecommendation.length > 0 ? group.primaryRecommendation[0] : group.primaryRecommendation;//fix for navigation issue from dashboard Favorite
                props.setGroup(group) 
                props.history.push('/dashboard/groupdetail');
            }
        } else if (element.ViewType === 2 || element.ViewType === 9) {//Score and CAS 
            //Product Division Level
            if (!utils.isEmpty(productDivision) && utils.isEmpty(customer) && utils.isEmpty(sbs) && utils.isEmpty(subregion)&& utils.isEmpty(strategicAccts)) {
                productDivision.primaryRecommendation = Array.isArray(productDivision.primaryRecommendation) && productDivision.primaryRecommendation.length > 0 ? productDivision.primaryRecommendation[0] : productDivision.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setProductDivision(productDivision) 
            }// Group Customer Level 
            else if (utils.isEmpty(productDivision) && !utils.isEmpty(customer) && utils.isEmpty(sbs) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                customer.primaryRecommendation = Array.isArray(customer.primaryRecommendation) && customer.primaryRecommendation.length > 0 ? customer.primaryRecommendation[0] : customer.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setCustomer(customer) 
            }// Business Unit Level 
            else if (!utils.isEmpty(productDivision) && !utils.isEmpty(sbs) && utils.isEmpty(customer) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                productDivision.primaryRecommendation = Array.isArray(productDivision.primaryRecommendation) && productDivision.primaryRecommendation.length > 0 ? productDivision.primaryRecommendation[0] : productDivision.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setProductDivision(productDivision) 
                sbs.primaryRecommendation = Array.isArray(sbs.primaryRecommendation) && sbs.primaryRecommendation.length > 0 ? sbs.primaryRecommendation[0] : sbs.primaryRecommendation;//fix for navigation issue from dashboard Favorite to SBS Detail
                props.setSelectedSBS(sbs) 
            }// PD Customer Level 
            else if (!utils.isEmpty(productDivision) && utils.isEmpty(sbs) && !utils.isEmpty(customer) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                productDivision.primaryRecommendation = Array.isArray(productDivision.primaryRecommendation) && productDivision.primaryRecommendation.length > 0 ? productDivision.primaryRecommendation[0] : productDivision.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setProductDivision(productDivision)
                customer.primaryRecommendation = Array.isArray(customer.primaryRecommendation) && customer.primaryRecommendation.length > 0 ? customer.primaryRecommendation[0] : customer.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setCustomer(customer) 
            } //Sub Region Level
            else if (!utils.isEmpty(subregion) && utils.isEmpty(productDivision) && utils.isEmpty(sbs) && utils.isEmpty(customer) && utils.isEmpty(strategicAccts)) {
                subregion.primaryRecommendation = Array.isArray(subregion.primaryRecommendation) && subregion.primaryRecommendation.length > 0 ? subregion.primaryRecommendation[0] : subregion.primaryRecommendation;
                props.setSubRegion(subregion); 
            } // Strategic Account Level
            else if (!utils.isEmpty(strategicAccts) && utils.isEmpty(subregion) && utils.isEmpty(productDivision) && utils.isEmpty(sbs) && utils.isEmpty(customer)) {
                strategicAccts.primaryRecommendation = Array.isArray(strategicAccts.primaryRecommendation) && strategicAccts.primaryRecommendation.length > 0 ? strategicAccts.primaryRecommendation[0] : strategicAccts.primaryRecommendation;//fix for navigation issue from dashboard Favorite
            props.setStrategicAct(strategicAccts);
           // props.history.push("/dashboard/strategicaccountsdetail");
           } //Group Level
            else {
                group.primaryRecommendation = Array.isArray(group.primaryRecommendation) && group.primaryRecommendation.length > 0 ? group.primaryRecommendation[0] : group.primaryRecommendation;//fix for navigation issue from dashboard Favorite
                props.setGroup(group) 
            }
            props.setCXScoreData(cxScoreDetails);
            props.setBreadCrumb(breadcrumb);
            props.setSASParent(sasParent);
            if (element.ViewType === 2) {
                if (sasParent === 'cx')
                    props.history.push("/dashboard/score");
                else
                    props.history.push("/dashboard/score/cas");
            } else {
                props.history.push("/dashboard/cas-childview");
            }
        } else if (element.ViewType === 3 || element.ViewType === 4 || element.ViewType === 5) {//KPI Views
            //Prod Division Level
            if (!utils.isEmpty(productDivision) && utils.isEmpty(customer) && utils.isEmpty(sbs) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                productDivision.primaryRecommendation = Array.isArray(productDivision.primaryRecommendation) && productDivision.primaryRecommendation.length > 0 ? productDivision.primaryRecommendation[0] : productDivision.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setProductDivision(productDivision)
            } //Group Customer Level 
            else if (utils.isEmpty(productDivision) && !utils.isEmpty(customer) && utils.isEmpty(sbs) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                customer.primaryRecommendation = Array.isArray(customer.primaryRecommendation) && customer.primaryRecommendation.length > 0 ? customer.primaryRecommendation[0] : customer.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setCustomer(customer)
            } //Business Unit Level
            else if (!utils.isEmpty(productDivision) && !utils.isEmpty(sbs) && utils.isEmpty(customer) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                productDivision.primaryRecommendation = Array.isArray(productDivision.primaryRecommendation) && productDivision.primaryRecommendation.length > 0 ? productDivision.primaryRecommendation[0] : productDivision.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setProductDivision(productDivision)
                sbs.primaryRecommendation = Array.isArray(sbs.primaryRecommendation) && sbs.primaryRecommendation.length > 0 ? sbs.primaryRecommendation[0] : sbs.primaryRecommendation;//fix for navigation issue from dashboard Favorite to SBS Detail
                props.setSelectedSBS(sbs)
            } // PD Customer Level
            else if (!utils.isEmpty(productDivision) && utils.isEmpty(sbs) && !utils.isEmpty(customer) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                productDivision.primaryRecommendation = Array.isArray(productDivision.primaryRecommendation) && productDivision.primaryRecommendation.length > 0 ? productDivision.primaryRecommendation[0] : productDivision.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setProductDivision(productDivision)
                customer.primaryRecommendation = Array.isArray(customer.primaryRecommendation) && customer.primaryRecommendation.length > 0 ? customer.primaryRecommendation[0] : customer.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setCustomer(customer) 
            } //Sub Region Level 
            else if (!utils.isEmpty(subregion) && utils.isEmpty(productDivision) && utils.isEmpty(sbs) && utils.isEmpty(customer) && utils.isEmpty(strategicAccts)) {
                subregion.primaryRecommendation = Array.isArray(subregion.primaryRecommendation) && subregion.primaryRecommendation.length > 0 ? subregion.primaryRecommendation[0] : subregion.primaryRecommendation;//fix for navigation issue from dashboard Favorite
                props.setSubRegion(subregion);
            } //Strategic Account Level
             else if (!utils.isEmpty(strategicAccts) && utils.isEmpty(subregion) && utils.isEmpty(productDivision) && utils.isEmpty(sbs) && utils.isEmpty(customer)) {
            strategicAccts.primaryRecommendation = Array.isArray(strategicAccts.primaryRecommendation) && strategicAccts.primaryRecommendation.length > 0 ? strategicAccts.primaryRecommendation[0] : strategicAccts.primaryRecommendation;//fix for navigation issue from dashboard Favorite
            props.setStrategicAct(strategicAccts);
           // props.history.push("/dashboard/strategicaccountsdetail");
           } else {//group level
                group.primaryRecommendation = Array.isArray(group.primaryRecommendation) && group.primaryRecommendation.length > 0 ? group.primaryRecommendation[0] : group.primaryRecommendation;//fix for navigation issue from dashboard Favorite
                props.setGroup(group)  
            }

            props.setCXScoreData(cxScoreDetails);  
            props.setSASParent('cx'); 
            props.setKPI(kpi)  
            props.setBreadCrumb(breadcrumb);
            if (element.ViewType === 3) {
                props.history.push("/dashboard/primaryview");
            } else if (element.ViewType === 4) {
                props.history.push("/dashboard/childview");
            } else {
                props.history.push("/dashboard/history");
            }
        } else if (element.ViewType === 6 || element.ViewType === 7 || element.ViewType === 8) {// NBA views
          
            //Prod Division Level
            if (!utils.isEmpty(productDivision) && utils.isEmpty(customer) && utils.isEmpty(sbs) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                productDivision.primaryRecommendation = Array.isArray(productDivision.primaryRecommendation) && productDivision.primaryRecommendation.length > 0 ? productDivision.primaryRecommendation[0] : productDivision.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setProductDivision(productDivision)
            } 
            // Customer Level
            else if (utils.isEmpty(productDivision) && !utils.isEmpty(customer) && utils.isEmpty(sbs) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                customer.primaryRecommendation = Array.isArray(customer.primaryRecommendation) && customer.primaryRecommendation.length > 0 ? customer.primaryRecommendation[0] : customer.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setCustomer(customer)
            } 
            // SBS Level
            else if (!utils.isEmpty(productDivision) && !utils.isEmpty(sbs) && utils.isEmpty(customer) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                productDivision.primaryRecommendation = Array.isArray(productDivision.primaryRecommendation) && productDivision.primaryRecommendation.length > 0 ? productDivision.primaryRecommendation[0] : productDivision.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setProductDivision(productDivision)
                sbs.primaryRecommendation = Array.isArray(sbs.primaryRecommendation) && sbs.primaryRecommendation.length > 0 ? sbs.primaryRecommendation[0] : sbs.primaryRecommendation;//fix for navigation issue from dashboard Favorite to SBS Detail
                props.setSelectedSBS(sbs)
            } // PD-Customer Level
            else if (!utils.isEmpty(productDivision) && utils.isEmpty(sbs) && !utils.isEmpty(customer) && utils.isEmpty(subregion) && utils.isEmpty(strategicAccts)) {
                productDivision.primaryRecommendation = Array.isArray(productDivision.primaryRecommendation) && productDivision.primaryRecommendation.length > 0 ? productDivision.primaryRecommendation[0] : productDivision.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setProductDivision(productDivision)
                customer.primaryRecommendation = Array.isArray(customer.primaryRecommendation) && customer.primaryRecommendation.length > 0 ? customer.primaryRecommendation[0] : customer.primaryRecommendation;//fix for navigation issue from dashboard Favorite to 
                props.setCustomer(customer)
            } //Sub Region Level
            else if (!utils.isEmpty(subregion) && utils.isEmpty(productDivision) && utils.isEmpty(sbs) && utils.isEmpty(customer) && utils.isEmpty(strategicAccts)) {
                subregion.primaryRecommendation = Array.isArray(subregion.primaryRecommendation) && subregion.primaryRecommendation.length > 0 ? subregion.primaryRecommendation[0] : subregion.primaryRecommendation;//fix for navigation issue from dashboard Favorite
                props.setSubRegion(subregion);
            } //Strategic Account Level 
            else if (!utils.isEmpty(strategicAccts) && utils.isEmpty(subregion) && utils.isEmpty(productDivision) && utils.isEmpty(sbs) && utils.isEmpty(customer)) {
                strategicAccts.primaryRecommendation = Array.isArray(strategicAccts.primaryRecommendation) && strategicAccts.primaryRecommendation.length > 0 ? strategicAccts.primaryRecommendation[0] : strategicAccts.primaryRecommendation;//fix for navigation issue from dashboard Favorite
            props.setStrategicAct(strategicAccts);
           // props.history.push("/dashboard/strategicaccountsdetail");
           } else {//Group Level
                group.primaryRecommendation = Array.isArray(group.primaryRecommendation) && group.primaryRecommendation.length > 0 ? group.primaryRecommendation[0] : group.primaryRecommendation;//fix for navigation issue from dashboard Favorite
                props.setGroup(group)
            }

            props.setNBA(nba)
            props.setNBABreadCrumb(breadcrumb);
            if (element.ViewType === 6) {
                props.history.push("/dashboard/nba/primaryview");
            } else if (element.ViewType === 7) {
                props.history.push("/dashboard/nba/childview");
            } else {
                props.history.push("/dashboard/nba/history");
            }
        }
    }

    async function getFavorites() {
        try {
            //setLoading(true);
            props.isFavLoading(true);
            console.log("getFavorites()---1---favorites");
            const favorites = await favUtils.getFavorites();
            console.log("getFavorites()---favorites", favorites);
            const processedFav = await favUtils.processFavorites(favorites)
            console.log("ProcessedFav--Region Selected", processedFav, JSON.parse(sessionStorage.getItem("selectedRegion")))
            const filteredProcessedFav = processedFav.filter((item) => item.region.toLowerCase() === JSON.parse(sessionStorage.getItem("selectedRegion")).toLowerCase())
            console.log("FilteredProcessFav", filteredProcessedFav)
            //  props.myPDCarouselChange();  
            //  props.myCustCarouselChange(); 
            //   props.mySubRegionCarouselChange(); 
            setFavorites(filteredProcessedFav)
            // props.isFavLoaded(true);
            props.setFavorite(favorites);
            //setLoading(false);
            handleShow();
            props.isFavLoading(false);
        } catch (err) {
            // setLoading(false)
            props.isFavLoading(false);
        }
    }

    async function removeFavorite(e, favorite) {
        try {
            //setLoading(true)
            props.isFavLoading(true);
            e.stopPropagation()
            await favUtils.removeFavorites(favorite.FavoriteId)
            await getFavorites()
            props.isFavLoading(false);
            //setLoading(false)
        } catch (err) {
            console.log(err);
            // setLoading(false)
            props.isFavLoading(false);
        }
    }


    const onClickFavScrollToEnd = () => {/*Left Fav Arrow- which takes to dead end */
        document.querySelector("#favoriteContainer #favScrollToEnd").style.display = "none";
        myFavCarousel?.current?.goTo(favorites.length);
    }

    const onClickFavScrollToStart = () => {
        document.querySelector("#favoriteContainer #favScrollToStart").style.display = "none";
        myFavCarousel?.current?.goTo(0);
    }

    const showHideLeftFavArrow = () => {
        console.log("showHideLeftFavArrow----my favorites are", favorites)
        // document.querySelector("#favoriteContainer #favScrollToEnd").style.display = "none";//document.querySelector("#favoriteContainer #favScrollToEnd").style.display = "block";
        if (document.querySelector("#favoriteContainer .rec.rec-arrow-left")) {
           // if (document.querySelector("#favoriteContainer .rec.rec-arrow-left").disabled && ((window.innerWidth >= 1150 && window.innerWidth < 1300 && favorites.length > 3) || (window.innerWidth >= 1300 && window.innerWidth < 1450 && favorites.length > 4) || (window.innerWidth >= 1450 && window.innerWidth < 1750 && favorites.length > 5) || (window.innerWidth >= 1750 && favorites.length > 6))) {
                if (document.querySelector("#favoriteContainer .rec.rec-arrow-left").disabled && ((window.innerWidth >= 1150 && window.innerWidth < 1250 && favorites.length > 3) || (window.innerWidth >= 1250 && window.innerWidth < 1400 && favorites.length > 4) || (window.innerWidth >= 1400 && window.innerWidth < 1600 && favorites.length >= 5) || (window.innerWidth >= 1600 && window.innerWidth < 1900 &&favorites.length >= 6) || (window.innerWidth >= 1900 && favorites.length > 7))) {
                document.querySelector("#favoriteContainer #favScrollToEnd").style.display = "block";
            }
            else {
                document.querySelector("#favoriteContainer #favScrollToEnd").style.display = "none";
            }
        }
    }

    const showHideRightFavArrow = () => {
        //    document.querySelector("#favoriteContainer #favScrollToStart").style.display = "none";
        if (document.querySelector("#favoriteContainer .rec.rec-arrow-right")) {
            //if (document.querySelector("#favoriteContainer .rec.rec-arrow-right") && favorites.length > 5) {
            // document.querySelector("#favoriteContainer #favScrollToStart").style.display = "none";
            //if (document.querySelector("#favoriteContainer .rec.rec-arrow-right").disabled && ((window.innerWidth < 1300 && favorites.length > 3) || (window.innerWidth >= 1300 && window.innerWidth < 1450 && favorites.length > 4) || (window.innerWidth >= 1450 && window.innerWidth < 1750 && favorites.length > 5) || (window.innerWidth >= 1750 && favorites.length > 6))) {
                if (document.querySelector("#favoriteContainer .rec.rec-arrow-right").disabled && ((window.innerWidth >= 1150 && window.innerWidth < 1250 && favorites.length > 3) || (window.innerWidth >= 1250 && window.innerWidth < 1400 && favorites.length > 4) || (window.innerWidth >= 1400 && window.innerWidth < 1600 && favorites.length >= 5) || (window.innerWidth >= 1600 && window.innerWidth < 1900 &&favorites.length >= 6) || (window.innerWidth >= 1900 && favorites.length > 7))) {
                document.querySelector("#favoriteContainer #favScrollToStart").style.display = "block";
            }
            else {
                document.querySelector("#favoriteContainer #favScrollToStart").style.display = "none";
            }
        }
    }

    const myFavCarouselChange = (current, pagenum) => {//NEED TO LOOK THIS
        showHideLeftFavArrow();
        showHideRightFavArrow();
    }

    const initialLoadArrow = () => {
        console.log("iniital Load Arrows---Resetting all arrows", favorites)
        if ((window.innerWidth >= 1150 && window.innerWidth < 1300 && favorites.length > 3) || (window.innerWidth >= 1300 && window.innerWidth < 1450 && favorites.length > 4) || (window.innerWidth >= 1450 && window.innerWidth < 1750 && favorites.length > 5) || (window.innerWidth >= 1750 && favorites.length > 6)) {
            document.querySelector("#favoriteContainer #favScrollToEnd").style.display = "block";
            document.querySelector("#favoriteContainer #favScrollToStart").style.display = "none";
        }
        if (favorites.length <= 3) {
            document.querySelector("#favoriteContainer #favScrollToEnd").style.display = "none";
            document.querySelector("#favoriteContainer #favScrollToStart").style.display = "none";
        }

    }

    useEffect(() => {
        //  setIsLoading(true);  

        getFavorites();
        // initialLoadArrow();
        myFavCarousel?.current?.goTo(0);
        // setIsLoading(false);
        document.querySelector("#favoriteContainer #favScrollToEnd").style.display = "none";
    }, [selectedRegion])

    useEffect(() => {
        initialLoadArrow();
    }, [favorites])

    // useEffect(() => {
    //     setFavorites([]);
    //     console.log("I am on useEffect--getFavorites")
    //     getFavorites();
    //     myFavCarousel?.current?.goTo(0);
    // }, [])


    // useEffect(() => {
    //   //  if (favorites.length > 0)
    //         myFavCarouselChange();
    // }, [favorites]);

    const favoriteBreakPoints = [
        { width: 1, itemsToShow: 1 },
        { width: 550, itemsToShow: 2, itemsToScroll: 2 },
        { width: 850, itemsToShow: 3, itemsToScroll: 2 },
        { width: 1150, itemsToShow: 4, itemsToScroll: 3 },
        { width: 1300, itemsToShow: 5, itemsToScroll: 4 },
        { width: 1450, itemsToShow: 5, itemsToScroll: 5 },
        { width: 1750, itemsToShow: 6, itemsToScroll: 6 }
    ]

    return (
        <div className={styles.favoriteContainer}>
            <div id="favoriteContainer" className={styles.favProductsContainer} >
                {
                    <div className={styles.scrollEndParent}>
                        <div id="favScrollToEnd" className={`${styles.leftFavArrow} ${styles.buttonStyle} `} onClick={() => onClickFavScrollToEnd()}>{"❮"}</div>
                    </div>
                }
                {favorites.length > 0 ? (
                    <div className={styles.customerLayoutBx}>
                        <Title value="Favorites" count={favorites.length} />
                        <Carousel ref={myFavCarousel}
                            onChange={(currentItem, pageIndex) =>
                                myFavCarouselChange(currentItem, pageIndex)}
                            breakPoints={favoriteBreakPoints}>
                            {favorites.map((item, index) => {
                                return (
                                    <Favorite
                                        key={index}
                                        favorite={item}
                                        {...props}
                                        type="customer"
                                        removeFavorite={removeFavorite}
                                        showDetail={viewFavorites}
                                    />
                                );
                            })}
                        </Carousel>
                    </div>
                ) : null}
                {<div className={styles.scrollStartParent}>
                    <div id="favScrollToStart" className={`${styles.rightFavArrow} ${styles.buttonStyle} `} onClick={() => onClickFavScrollToStart()}>{"❯"}</div>
                </div>}
            </div>
        </div>

    )


};

export default FavDashboard;